import React, { useRef, useState } from 'react'
import { Button, FormFeedback, FormGroup, Input, Label, Row, Col, Card, CardBody, Container, CardHeader, Badge ,ButtonGroup, Table } from 'reactstrap'
import { useProfiles } from '../../../hooks/profiles/useProfiles'
import './StyleProfile.css';
import { SearchAsync } from '../../../components/elements/SearchAsync';
import { InformationPriceComercialLine } from './InformationPriceComercialLine';
import { useHistory } from 'react-router-dom';
import { ModalOrderExam } from './ModalOrderExam';
import { ModalPrice } from './Prices/ModalPrice';
import { ModalPriceProfile } from './Prices/ModalPriceProfile'; 
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ModalSectionExam } from './ModalSectionExam';
import {cedimi} from '../../../constant/globalConstantsTypeClients'
import 'primeicons/primeicons.css';
import { ModalOrderAnalyte } from './analyte/ModalOrderAnalyte';
import { TabMenu } from "primereact/tabmenu";


export const IndexPriceExam = () => {

    const history = useHistory();

    const {
        name, handleInputChange, abbreviation, code, is_critic, is_curve, sampling_cost, loading,delivery_time,
        id_exam, exam, searchPrice, rangeval, totalCommercialLines, method,
        handleChange, handleChangeExam, saveCreate, handleDeleteExamGlobal,
        saveUpdate, handleChangeSinToma, handleChangeConToma,
        validationsProfile,
        sendKitSampling, id_profile, listFirstPrice,
        //OrderByExam
        handleOrderByExam,toggleOrderByExam,methodOrder,titleOrder,modalOrder,
        data,changeOrder,cambiar, handleSaveOrderExamsAnalyte,
        //modal Prices
        titlePrice,typeprice,handleprices,togglePrice,modalPrice,calcularPorcentajeDescuento,resul,porcentaje,arrayExams,llavecard,
        setFindRate,findRate,

        // ? CONFIGURATION MICRO
        is_micro,

        // ? Copy Profile
        handleChangeProfile, examsData,totalCommercialLinesProfiles,getProfileExams, totalPrice, totalServicioReferencia,
        totalReferencia, totalPublico, handlePricesProfile, calcularPorcentajeDescuentoProfile, togglePriceProfile,
        typepriceProfile,modalPriceProfile, handleDiscountChange, discounts, discountPrice, discount, finalPrice, 

          // ? section examn
          handleSectionExam, modalSectionExam, toggleSectionExam, titleSectionExam, getSections, sections,
          handleFormSection, modalFormSection, toggleFormSection, titleFormSection,
          methodFormSection,saveSamplingPlan,
          valueGroup,handleChangeGroup,    selectedSections,handleSectionChange,saveGroup,
          dat4,selectedSections1,handleDeleteSelection,profilesId,

        // ? Order Profile
        listOrderProfiles, saveOrderProfiles, profileOrder, profileId, setProfileOrder, visibleOrder, setVisibleOrder,
        handleOrderByProfile, individual_saleP, id_section, handleSelectValues, sectionsProfile,  handleSearchP, exportToExcel,
        setSearchTerm, searchTerm



    } = useProfiles();
          console.log("🚀 ~ profileId2:", profileId)
       
    
      

    const {
        nameValid,
        abbreviationValid,
        codeValid,
    } = validationsProfile;

    const childCompRef = useRef();


        //*SLIDER CONTROLS
        const CustomPrevArrow = (props) => (
            <button {...props} className="slick-arrow slick-prev">
            <i className= "icon-arrow-circle-left labelCommercialLine f-32 " ></i>
            </button>
        );
        
        const CustomNextArrow = (props) => (
            <button {...props} className="slick-arrow slick-next" style={{ right: '5px' }}>
            <i className= "icon-arrow-circle-right labelCommercialLine f-32 "></i>        
            </button>
        );

      //*BOOL TYPE KIT
      const [typeKit, setTypeKit] = useState(false)

      const handleKit = (_valid) => {
        setTypeKit(_valid)
      }

      //*INDEX SLIDER

      const sliderRef = useRef(null); 

      const scrollToSlider = (_id_rate) => {
        setFindRate(_id_rate)

        if (sliderRef.current) {
            const index = searchPrice.findIndex(_find => _find.id_rate === _id_rate);
            if (index !== -1) {
                sliderRef.current.slickGoTo(index); 
            }
        }
    };

    let ur_helen = localStorage.getItem('url_helen');

    const [activeIndex, setActiveIndex] = useState(0);


    const items = searchPrice.map((objj, index) => {
        const findSearchPrice = searchPrice.find(x => x.id_rate === objj.id_rate);

        return {
            label: `${objj.name_rate} $${findSearchPrice?.price_profile?.toFixed(2) ?? "0.00"}`,
            command: () => setActiveIndex(index),
        };
    });

    let typeMenu = localStorage.getItem('menu') === "True";


    return (
        <div className='container-global-zoom'  > 
            <Row className={` ${typeMenu ? "p-2" : ""}`}>
                <Col lg="4">
                    <Card>
                            <Col sm="12" className='mt-2'>
                                <div style={{
                                    backgroundColor: '#13a4ec', 
                                    color: '#fff', 
                                    padding: '5px 10px', 
                                    borderRadius: '8px', 
                                    marginBottom: '10px', 
                                    fontWeight: 'bold', 
                                    textAlign: 'center',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                    display: 'flex', 
                                    alignItems: 'center', 
                                    justifyContent: 'space-between',
                                    cursor: 'pointer',
                                    transition: 'all 0.3s ease', 
                                }} onClick={() => window.history.back()}>
                                    <i className="fa fa-reply 3x" title='Regresar a la lista de perfiles' style={{
                                        fontSize: '18px', 
                                        marginLeft: '10px', 
                                        transition: 'transform 0.3s ease', 
                                    }}></i>
                                    
                                    <div style={{
                                        flex: 1, 
                                        textAlign: 'center', 
                                        marginLeft: '20px', 
                                    }}>
                                        Datos Generales
                                    </div>
                                </div>



                                <FormGroup className="mt-2">
                                <label>
                                    Nombre del Perfil
                                    <span className="f-16" style={{ color: "#0079C7" }}>*</span>
                                </label>
                                <Input
                                    className="form-control input-air-primary form-control-sm"
                                    style={{ borderRadius: "0.5rem" }}
                                    name="name"
                                    value={name}
                                    required={true}
                                    autoComplete="nope"
                                    onChange={handleInputChange}
                                    invalid={nameValid}
                                />
                                <FormFeedback>El nombre debe tener 3 o más caracteres</FormFeedback>
                                </FormGroup>

                                <Row>
                                    <Col sm="6">
                                        <FormGroup className=''>
                                        <Label className="col-form-label text-sm">
                                            Abreviatura del Perfil
                                            <span className="f-16" style={{ color: "#0079C7" }}>*</span>
                                        </Label>
                                        <Input
                                            type="text"
                                            className="form-control input-air-primary form-control-sm"
                                            style={{ borderRadius: "0.5rem" }}
                                            name="abbreviation"
                                            value={abbreviation}
                                            required={true}
                                            autoComplete="nope"
                                            onChange={handleInputChange}
                                            invalid={abbreviationValid}
                                        />
                                        <FormFeedback>Debe contener más de 3 caracteres</FormFeedback>
                                        </FormGroup>
                                    </Col>

                                    <Col sm="6">
                                        <FormGroup className=''>
                                        <Label className="col-form-label text-sm">
                                            Clave del Perfil
                                            <span className="f-16" style={{ color: "#0079C7" }}>*</span>
                                        </Label>
                                        <Input
                                            type="text"
                                            className="form-control input-air-primary form-control-sm"
                                            style={{ borderRadius: "0.5rem" }}
                                            name="code"
                                            value={code}
                                            required={true}
                                            autoComplete="nope"
                                            onChange={handleInputChange}
                                            invalid={codeValid}
                                        />
                                        <FormFeedback>Debe contener mínimo 1 caracter</FormFeedback>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm="6">
                                        <FormGroup className=''>
                                            <Label className="col-form-label text-sm">
                                                Tiempo de entrega
                                            </Label>
                                            <Input
                                                type="text"
                                                className="form-control input-air-primary form-control-sm"
                                                style={{ borderRadius: "0.5rem" }}
                                                name="delivery_time"
                                                value={delivery_time}
                                                required={true}
                                                autoComplete="nope"
                                                onChange={handleInputChange}
                                            />

                        
                                        </FormGroup>
                                    </Col>
                                    <Col sm="6">
                                        <FormGroup className=''>
                                        <Label className="col-form-label text-sm">Perfil Crítico</Label>
                                        <div className="checkbox checkbox-solid-danger pl-3">
                                            <Input
                                            id="solid4"
                                            type="checkbox"
                                            name="is_critic"
                                            onChange={handleInputChange}
                                            checked={is_critic}
                                            />
                                            <Label for="solid4">¿Es crítico?</Label>
                                        </div>
                                        </FormGroup>
                                    </Col>
                                </Row>

                                <Row>
                                    
                                    <Col sm="6">
                                        <FormGroup className=''>
                                        <Label className="col-form-label text-sm">
                                            Perfil de Microsanitaria
                                        </Label>
                                        <div className="checkbox checkbox-solid-success pl-3">
                                            <Input
                                            id="lis_micro"
                                            type="checkbox"
                                            name="is_micro"
                                            onChange={handleInputChange}
                                            checked={is_micro}
                                            />
                                            <Label for="lis_micro">¿Microsanitaria?</Label>
                                        </div>
                                        </FormGroup>
                                    </Col>

                                    <Col sm="6">
                                        <FormGroup className=''>
                                            <Label className="col-form-label text-sm">
                                            Perfil de venta individual
                                            </Label>
                                        <div className="checkbox checkbox-solid-info pl-3">
                                            <Input
                                            id="individual_saleP"
                                            type="checkbox"
                                            name="individual_saleP"
                                            onChange={handleInputChange}
                                            checked={individual_saleP}
                                            />
                                            <Label for="individual_saleP">¿Venta Individual?</Label>
                                        </div>
                                        </FormGroup>
                                    </Col>

                                </Row>
                            </Col>

                            {/* SECCIÓN 2 - EXÁMENES A INCLUIR */}
                            <Col sm="12" >
                                <div style={{ 
                                        backgroundColor: '#6b91a8', 
                                        color: '#fff', 
                                        padding: '5px 10px', 
                                        borderRadius: '8px', 
                                        marginBottom: '10px', 
                                        fontWeight: 'bold', 
                                        textAlign: 'center',
                                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                    }}>
                                        Configuración
                                </div>
                                {
                                    //*COMPONENT SEARCH AND KIT SAMPLE
                                }
                                <Row>
                                    <Col sm="12"> <br />
                                        <Label className="col-form-label text-sm">
                                            Exámen a incluir en el perfil
                                        </Label>
                                        
                                        <FormGroup className='p-2'>
                                            <SearchAsync
                                                value={id_exam}
                                                name="id_exam"
                                                method={handleChangeExam}
                                                loincState={exam}
                                                url={`Profiles/SearchProfileExam?is_profile=true`}
                                                maxLenght={3}
                                                placeholder="Búsqueda de exámen"
                                                className="form-control-sm input-air-primary"
                                            />
                                        </FormGroup>
                                        
                                    </Col>
                                </Row>

                                <Row>
                                    <Col sm="9">
                                        <Label className="col-form-label text-sm p-2">
                                            Perfiles a incluir en el perfil
                                        </Label>

                                        <FormGroup className="w-100">
                                            <SearchAsync
                                                value={id_exam}
                                                name="id_exam"
                                                loincState={exam}
                                                url="Profiles/SearchProfile"
                                                maxLenght={3}
                                                method={handleChangeProfile}
                                                placeholder="Búsqueda de perfiles"
                                                className="form-control-sm input-air-primary w-100"
                                            />
                                        </FormGroup>
                                        
                                    
                                    </Col>

                                    <Col sm="3" className='p-2'> <br /><br />
                                        <Button
                                            outline
                                            color="primary"
                                            size="sm"
                                            onClick={() => getProfileExams(id_exam)}
                                            style={{
                                            fontSize: '12px',
                                            padding: '2px 5px', 
                                            backgroundColor: '#51bb25',
                                            borderColor: '#51bb25',
                                            color: 'white',
                                            width: '100%',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            whiteSpace: 'nowrap',   
                                            }}
                                        >
                                            Incluir Perfil
                                        </Button>
                                    </Col>

                                    
                                </Row>
                                <br />
                                <Row className="d-flex justify-content-center align-items-center">
                                    {ur_helen !== cedimi && (
                                        <Col className={`text-center ${ur_helen !== cedimi ? "col-6" : "col-4"}`}>
                                        <Button outline color="primary" size="sm" onClick={handleOrderByExam} 
                                            style={{
                                                fontSize: '12px',
                                                padding: '5px',
                                                backgroundColor: '#287fa7ff',  
                                                borderColor: '#287fa7ff',
                                                color: 'white',
                                                width: '100%',  
                                            }}>
                                            <i className="pi pi-sort-alt" style={{ fontSize: '12px' }}></i> Ordenar Exámenes
                                        </Button>
                                        </Col>
                                    )}

                                    <Col sm="6" className={profilesId === undefined ? "d-none" : "text-center"}>
                                        <Button outline color="primary" size="sm" onClick={() => handleSectionExam()}  style={{
                                                fontSize: '12px',
                                                padding: '5px',
                                                backgroundColor: '#287fa7ff',  
                                                borderColor: '#287fa7ff',
                                                color: 'white',
                                                width: '100%',  
                                            }}>
                                        <i className="pi pi-th-large" style={{ fontSize: "12px" }}></i> Bloques de Exámenes
                                        </Button>
                                    </Col>

                                    {ur_helen === cedimi && (
                                        <Col sm="6" className="text-center p-2">
                                        <Button outline color="primary" size="sm" onClick={() => handleOrderByProfile()}
                                            
                                            style={{
                                                fontSize: '12px',
                                                padding: '5px',
                                                backgroundColor: '#287fa7ff',  
                                                borderColor: '#287fa7ff',
                                                color: 'white',
                                                width: '100%',  
                                            }}>
                                            <i className="pi pi-sort-amount-up" style={{ fontSize: "13px" }}></i> Ordenar Perfil
                                        </Button>
                                        </Col>
                                    )}
                                </Row>
                                    <br />
                                  <Row className="d-flex justify-content-center align-items-center">
                                    <Col sm="11" >
                                       <Button
                                        onClick={(method === 'create' ? saveCreate : saveUpdate)}
                                        disabled={loading}
                                        color="primary"
                                        block
                                        outline
                                        className="mt-4 p-2"
                                        style={{
                                            borderRadius: '8px',
                                            padding: '6px',
                                            fontSize: '14px',
                                            fontWeight: 600,
                                            borderWidth: '2px'
                                        }}
                                        onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                        onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                    >
                                        {(method === 'create' ? "Crear Perfil" : "Actualizar Perfil" )}
                                    </Button>
                                    
                                    </Col>
                                 
                                    
                               
                                    
                                </Row>
                            </Col>
                            
                            
                        <br /><br /><br />
                    </Card>
                </Col>

                
                <Col sm="8" className={` ${typeMenu ? "p-3" : ""}`}>
                
                <div>
                    <div style={{ position: "relative", marginBottom: "40px" }}>
                        <div
                            style={{
                                position: "absolute",
                                top: "-20px",
                                left: "50%",
                                transform: "translateX(-50%)",
                                backgroundColor: "#ffa724ff",
                                color: "#fff",
                                padding: "6px 25px",
                                borderRadius: "25px",
                                fontWeight: 700,
                                fontSize: "16px",
                                boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
                                zIndex: 10,
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                            }}
                        >
                            <i className="icofont icofont-hand-pointer" style={{ fontSize: "13px", color: "#fff" }}></i>
                            Seleccione un tarifario
                        </div>

                        {totalCommercialLines.length > 0 && searchPrice.length > 0 ? (
                            <>
                                <TabMenu
                                    model={items}
                                    activeIndex={activeIndex}
                                    onTabChange={(e) => setActiveIndex(e.index)}
                                    style={{ marginBottom: "15px" }}
                                    className="custom-tabmenu full-width custom-tabmenu-orange"
                                />

                                <InformationPriceComercialLine
                                    objj={searchPrice.find(x => x.id_rate === totalCommercialLines[activeIndex].id_rate)}
                                    handleChange={handleChange}
                                    index={activeIndex}
                                    handleDeleteExamGlobal={handleDeleteExamGlobal}
                                    totalCommercialLines={totalCommercialLines}
                                    handleChangeSinToma={handleChangeSinToma}
                                    handleChangeConToma={handleChangeConToma}
                                    findFirstPrice={listFirstPrice.find(x => x.id_rate === totalCommercialLines[activeIndex].id_rate)}
                                    sampling_cost={sampling_cost}
                                    handleprices={handleprices}
                                    porcentaje={porcentaje}
                                    typeKit={typeKit}
                                    setFindRate={setFindRate}
                                    searchTerm={searchTerm}
                                    setSearchTerm={setSearchTerm}
                                    exportToExcel={exportToExcel}
                                />
                            </>
                        ) : (
                            <>
                            <br /><br /><br />
                                <div className="text-center">
                                    <img
                                        src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                        style={{ width: "70%" }}
                                        alt="Sin Cotizaciones"
                                    />
                                    <br />
                                    <p className="badge badge-light-primary mt-2" style={{ fontSize: "20px" }}>
                                        Sin estudios en el perfil.
                                    </p>
                                </div>
                            
                            </>
                        
                        )}
                    </div>

                </div>
           
                
                   {/* <div style={{paddingTop: "15px", paddingLeft: "15px", paddingRight: "15px", scrollBehavior: "smooth", transform: "scale(0.8)", width: "125%", transformOrigin: "top left", textAlign: "justify"}}>
                         {searchPrice.length >= 1 && (
                        <Slider
                            ref={sliderRef}
                            dots={false}
                            infinite={true}
                            speed={500}
                            slidesToShow={1}
                            slidesToScroll={1}
                            style={{ width: "100%", height: "100%" }}
                            prevArrow={<CustomPrevArrow />}
                            nextArrow={<CustomNextArrow />}
                            >
                            {searchPrice.map((objj, index) => {
                                let findFirstPrice = listFirstPrice.find(x => x.id_rate == objj.id_rate);
                                console.log("🚀 ~ {searchPrice.map ~ findFirstPrice:", findFirstPrice)
                                return (
                                    <InformationPriceComercialLine
                                        
                                        {
                                        ...{
                                            objj, handleChange, rangeval, index, handleDeleteExamGlobal, totalCommercialLines, handleChangeSinToma, handleChangeConToma, totalCommercialLines, findFirstPrice,
                                            titlePrice,typeprice,handleprices,togglePrice,modalPrice,calcularPorcentajeDescuento,resul,porcentaje,handleInputChange,arrayExams,llavecard,
                                            typeKit,setFindRate
                                        }
                                        }
                                    />
                                )
                            })}
                        </Slider>
                    )}
                   </div> */}

                </Col>



            </Row>
        

            {
                //*COMPONENT SLIDER
            }
            {
                // <Card className='floating-card p-1'>
                //     {
                //         //*BUTTON SAVE 
                //     }
                //     <CardBody className='p-1'>
                //     {
                //         searchPrice.length >= 1 &&
                //         <ButtonGroup
                //         vertical
                //     >
                //         <Button
                //             block={true}
                //             size="lg"
                //             onClick={() => history.goBack()}
                //             outline color='danger'
                //         >
                //             <i className="icofont icofont-arrow-left"></i>
                //         </Button>
                //         <Button
                //             block={true}
                //             size="lg "
                //             onClick={(method === 'create' ? saveCreate : saveUpdate)}  
                //             outline color='info'
                //             className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                //             id={`tooltip-navigates-${"a"}`}
                //         >
                //             <i className="icofont icofont-diskette"></i>
                //         </Button>
                //     </ButtonGroup>
                //     }
                //     </CardBody>
                // </Card>
            }



                {
                    //*COMPONENTS
                }
                {
                <ModalOrderExam
                    {
                        ...{  handleOrderByExam, toggleOrderByExam, titleOrder, modalOrder, data, cambiar, handleSaveOrderExamsAnalyte,method}
                    }
                /> 
                }
                {
                <ModalPrice
                    key={llavecard}
                    {
                        ...{titlePrice,typeprice,handleprices,togglePrice,modalPrice,totalCommercialLines,
                            calcularPorcentajeDescuento,resul,porcentaje,handleInputChange,arrayExams,llavecard,findRate,}
                    }
                />
                }

                {
                <ModalPriceProfile
                    key={llavecard}
                    {
                        ...{titlePrice,typepriceProfile,handlePricesProfile,togglePriceProfile,modalPriceProfile,totalCommercialLines,
                            calcularPorcentajeDescuentoProfile,resul,porcentaje,handleInputChange,arrayExams,llavecard,findRate,}
                    }
                />
                }

                {
                <ModalSectionExam
                    {
                        ...{ handleSectionExam, modalSectionExam, toggleSectionExam, titleSectionExam, data, getSections, 
                            sections, handleFormSection, modalFormSection, toggleFormSection, titleFormSection, methodFormSection,saveSamplingPlan,
                            valueGroup,handleChangeGroup,    selectedSections,handleSectionChange,saveGroup,dat4,selectedSections1,
                            handleDeleteSelection


                        }
                    }
                />
                }

                {
                <ModalOrderAnalyte
                    {
                        ...{ 
                            // ? Order Analyte
                            visibleOrder, changeOrder, data,  profilesId ,listOrderProfiles, saveOrderProfiles, profileOrder, setProfileOrder,
                            setVisibleOrder


                        }
                    }
                />
                }

        </div>
    )
}